import { useEffect, useState } from "react";
import "../../css/GameRoom.css"
import GameCard from "./GameCard";
import { useNavigate } from "react-router-dom";

const GameLoader = ({allGamesArray, handleCardClick, clearData}) => {

    const [searchText, setSearchText] = useState("");
    const [gameType, setGameType] = useState("");
    const [currentPage, setCurrentPage] = useState(1);

    const pageSize = 50;

    const navigate = useNavigate();

    useEffect(()=>{
        clearData();
    },[])

    useEffect(() => {
        setCurrentPage(1);
    }, [searchText, gameType]);


    const getFilteredGames = () => {
        if (searchText !== "") {
            // If searching, return up to 50 matches, ignore pagination
            return allGamesArray.filter(game =>
            game.gameName.toLowerCase().includes(searchText.toLowerCase()) ||
            game.userName.toLowerCase().includes(searchText.toLowerCase())
            ).slice(0, pageSize);
        }
        let filteredArray = allGamesArray;
        if (gameType !== "") {
            filteredArray = allGamesArray.filter(game =>
            game.gameType.toLowerCase().includes(gameType.toLowerCase())
            );
        }
        return filteredArray;
    };

    const filteredGames = getFilteredGames();
    const totalPages = Math.ceil(
            searchText ? 1 : (filteredGames.length / pageSize)
        );

    const paginatedGames = searchText
        ? filteredGames // If searching, just the 50 matches
        : filteredGames.slice((currentPage - 1) * pageSize, currentPage * pageSize);

    const handlePageChange = (pageNum) => {
        setCurrentPage(pageNum);
    };


    const handleInputText = (event) =>{
        setSearchText(event.target.value);
    }

    const handleGameTypeClick = (gameType) =>{
        setGameType(gameType);
    }

    const handleNavigate = (link) =>{
        navigate(link);
    }

    return(
        <div style={{width:"100%", height:"100dvh", position:"relative", overflow:"hidden", justifyContent:"space-evenly"}}>
            <img 
                src="/assets/games/gameroom/gr_toppaper.png"
                className="gr-toppaper"
            />

            <img 
                src="/assets/games/gameroom/cardboard.png"
                style={{position:"absolute", top:"0", height: "100%", width:"100%", zIndex:"-10"}}
            />

            <img 
                src="/assets/games/gameroom/gametory_logo.png"
                style={{position:"absolute", width:"50px", top:"10px", left:"10px", cursor:"pointer"}}
                onClick={()=>handleNavigate("/")}
            />

            <div style={{display:"flex", width:"100%", height:"100%", flexDirection:"column", alignItems:"center", justifyContent:"flex-start", zIndex:"20"}}>
                <div style={{display:"flex", justifyContent:"center", alignItems:"flex-end", padding:"11px", fontFamily:"Lexend", fontSize:"31px", fontWeight:"bold"}}>
                    GAME ROOM
                </div>

                <div style={{height:"40px", display:"flex", width:"100%", justifyContent:"space-between", alignItems:"center", padding:"0px 20px"}}>
                    
                    <div style={{display:"flex",alignItems:"center", justifyContent:"space-between", width:"100%"}}>
                        <div className="center-child" style={{width:"30px", height:"30px", backgroundColor:"black", borderRadius:"50%", margin:"0px 5px"}}>
                            <img src="/assets/icon/gallery_icon_white.png" style={{width:"60%", cursor:"pointer"}} onClick={()=>handleGameTypeClick("")}/>
                        </div>
                        
                        <div style={{display:"flex", flex:"3" ,overflowX:"auto", padding:"0px 10px"}}>
                            <img src="/assets/games/gameroom/jumper_icon.png" style={{height:"30px", margin:"0px 2px", cursor:"pointer"}} onClick={()=>handleGameTypeClick("jumper")}/>
                            <img src="/assets/games/gameroom/runner_icon.png" style={{height:"30px", margin:"0px 2px", cursor:"pointer"}} onClick={()=>handleGameTypeClick("runner")}/>
                            <img src="/assets/games/gameroom/invader_icon.png" style={{height:"30px", margin:"0px 2px", cursor:"pointer"}} onClick={()=>handleGameTypeClick("invader")}/>
                            <img src="/assets/games/gameroom/platformer_icon.png" style={{height:"30px", margin:"0px 2px", cursor:"pointer"}} onClick={()=>handleGameTypeClick("platformer")}/>
                            {/*<img src="/assets/games/gameroom/mazer_icon.png" style={{height:"30px", margin:"0px 2px", cursor:"pointer"}} onClick={()=>handleGameTypeClick("mazer")}/>
                            <img src="/assets/games/gameroom/swimmer_icon.png" style={{height:"30px", margin:"0px 2px", cursor:"pointer"}} onClick={()=>handleGameTypeClick("swimmer")}/>
                            <img src="/assets/games/gameroom/racer_icon.png" style={{height:"30px", margin:"0px 2px", cursor:"pointer"}} onClick={()=>handleGameTypeClick("racer")}/>
                            <img src="/assets/games/gameroom/popper_icon.png" style={{height:"30px", margin:"0px 2px", cursor:"pointer"}} onClick={()=>handleGameTypeClick("popper")}/>*/}
                        </div>

                        <div style={{display:"flex",position:"relative", flex:"1", alignItems:"center", right:"5px", maxWidth:"25%"}}>
                            <input 
                                type="text" 
                                id="search-input" 
                                placeholder="Search..." 
                                style={{height:"22px", width:"100%", zIndex:"5", marginLeft:"5px", paddingLeft:"5px", borderTopLeftRadius:"15px",  borderBottomLeftRadius:"15px", fontFamily:"Quicksand, sans-serif"}}
                                onChange={handleInputText}
                                value={searchText}
                            />
                            <div style={{position:"absolute", backgroundColor: "black", height:"30px", width:"150%", left:"0", borderTopLeftRadius:"15px",  borderBottomLeftRadius:"15px"}}></div>
                        </div>
                        
                    </div>
                </div>

                <div className="game-container">
                    {allGamesArray && allGamesArray.length > 0 && (
                        <div style={{
                        height: "100%", width: "100%", display: "flex", flexWrap: "wrap",
                        justifyContent: "center", alignContent: "flex-start", overflowY: "auto"
                        }}>
                        {paginatedGames.map(game => (
                            <GameCard
                            key={game.userId + "_" + game.gameId}
                            game={game}
                            handleCardClick={handleCardClick}
                            />
                        ))}
                        </div>
                    )}
                </div>

                {/* Pagination - hidden during search */}
                <div style={{display:"flex", justifyContent:"center", height:"100px"}}>
                    <div className="pagination-scroll" style={{width:"70%", height:"80%", overflowX:"auto", overflowY:"hidden"}}>
                        {!searchText && totalPages > 1 && (
                            <div style={{ display: "flex", justifyContent: "flex-start", maxWidth:"50%", margin: "10px 0"}}>
                                {Array.from({ length: totalPages }, (_, i) => (
                                    <button
                                        key={i + 1}
                                        style={{
                                            margin: "0 2.5px",
                                            padding: "3px 8px",
                                            borderRadius: "5px",
                                            background: currentPage === i + 1 ? "#ffd700" : "white",
                                            border: "1px solid #bbb",
                                            cursor: "pointer",
                                            fontFamily:"Lexend",
                                            fontWeight: currentPage === i + 1 ? "bold" : "normal",
                                        }}
                                        onClick={() => handlePageChange(i + 1)}
                                    >
                                    {i + 1}
                                    </button>
                                ))}
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default GameLoader;